import React from 'react'

import PropTypes from 'prop-types'

import './componentpartners.css'

const Componentpartners = (props) => {
  return (
    <div
      className={`componentpartners-thq-layout226-elm thq-section-padding ${props.rootClassName} `}
    >
      <div className="componentpartners-container1">
        <span className="componentpartners-thq-description2-elm1">
          Стратегические партнеры
        </span>
        <div className="componentpartners-container2">
          <a
            href="https://kawasakirobotics.com/"
            target="_blank"
            rel="noreferrer noopener"
            className="componentpartners-link1"
          >
            <img
              alt="Kawasaki Robotics"
              loading="lazy"
              src="/0_Main_page/feature2/Experience/kawasaki-200h.webp"
              className="componentpartners-image10"
            />
          </a>
          <a
            href="https://kolarc.com/"
            target="_blank"
            rel="noreferrer noopener"
            className="componentpartners-link2"
          >
            <img
              alt="Kolarc"
              loading="lazy"
              src="/0_Main_page/feature2/Experience/kolarc%20-200h.webp"
              className="componentpartners-image11"
            />
          </a>
        </div>
        <span className="componentpartners-thq-description2-elm2 H1_medium">
          Опыт интеграции
        </span>
        <div className="componentpartners-container3">
          <img
            alt="Fanuc"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/fanuc-200h.webp"
            className="componentpartners-image12"
          />
          <img
            alt="KUKA"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/kuka-200h.webp"
            className="componentpartners-image13"
          />
          <img
            alt="Yaskawa"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/yaskawa-200h.webp"
            className="componentpartners-image14"
          />
          <img
            alt="Kawasaki Robotics"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/kawasaki-200h.webp"
            className="componentpartners-image15"
          />
          <img
            alt="Kolarc"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/kolarc%20-200h.webp"
            className="componentpartners-image16"
          />
        </div>
        <div className="componentpartners-container4">
          <img
            alt="Fronius"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/fronius-200h.webp"
            className="componentpartners-image17"
          />
          <img
            alt="EWM"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/ewm.svg-200h.webp"
            className="componentpartners-image18"
          />
          <img
            alt="Abicor"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/abicor-200h.webp"
            className="componentpartners-image19"
          />
          <img
            alt="Lorch"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/lorch-200h.webp"
            className="componentpartners-image20"
          />
          <img
            alt="Basler"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/basler-200h.webp"
            className="componentpartners-image21"
          />
        </div>
        <span className="componentpartners-thq-description2-elm3 H1_medium">
          Нам доверяют
        </span>
        <div className="componentpartners-container5">
          <img
            alt="Kazzinc"
              loading="lazy"
            src="/0_Main_page/feature2/trusted/kazzinc-200h.webp"
            className="componentpartners-image22"
          />
          <img
            alt="Kaz Minerals"
              loading="lazy"
            src="/0_Main_page/feature2/trusted/kaz_minerals_logo.svg-scaled-200h.webp"
            className="componentpartners-image23"
          />
          <img
            alt="ERG"
              loading="lazy"
            src="/0_Main_page/feature2/trusted/erg%202-200h.webp"
            className="componentpartners-image24"
          />
          <img
            alt="KLMZ"
              loading="lazy"
            src="/0_Main_page/feature2/trusted/klmz-200h.webp"
            className="componentpartners-image25"
          />
          <img
            alt="Казахмыс"
              loading="lazy"
            src="/0_Main_page/feature2/trusted/kazakhmys-200h.webp"
            className="componentpartners-image26"
          />
          <img
            alt="ПГ АЭС"
              loading="lazy"
            src="/0_Main_page/feature2/trusted/%C3%B0%C2%9B%C3%B0%C2%BE%C3%B0%C2%B3%C3%B0%C2%BE%20%C3%B0%C2%9F%C3%B0%C2%97%C3%B0%C2%A2%C3%B0%C2%90-200h.webp"
            className="componentpartners-image27"
          />
          <img
            alt="КБТУ"
              loading="lazy"
            src="/0_Main_page/feature2/trusted/kbtu-200h.webp"
            className="componentpartners-image28"
          />
          <img
            alt="TAGA"
              loading="lazy"
            src="/0_Main_page/feature2/Experience/taga1-200h.webp"
            className="componentpartners-image29"
          />
          <img
            alt="ЕКТУ"
              loading="lazy"
            src="/0_Main_page/feature2/trusted/ektu-200h.webp"
            className="componentpartners-image30"
          />
          <img
            alt="KazEnergy Power"
              loading="lazy"
            src="/0_Main_page/feature2/trusted/%C3%B0%C2%BB%C3%B0%C2%BE%C3%B0%C2%B3%C3%B0%C2%BE%C3%B1%C2%82%C3%B0%C2%B8%C3%B0%C2%BF%20kazenergo%20power%20%C3%B0%C2%BE%C3%B1%C2%81%C3%B0%C2%BD%C3%B0%C2%BE%C3%B0%C2%B2%C3%B0%C2%BD%C3%B0%C2%BE%C3%B0%C2%B8%C3%AC%C2%86%20%C3%B0%C2%B1%C3%B0%C2%B5%C3%B0%C2%B7%20%C3%B1%C2%84%C3%B0%C2%BE%C3%B0%C2%BD%C3%B0%C2%B0-200h.webp"
            className="componentpartners-image31"
          />
        </div>
      </div>
    </div>
  )
}

Componentpartners.defaultProps = {
  rootClassName: '',
}

Componentpartners.propTypes = {
  rootClassName: PropTypes.string,
}

export default Componentpartners
